// @todo: Migrate to 'Tabs' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as Tabs from '@wandb/weave/components/Tabs';
import React, {useState} from 'react';

import * as Types from '../../../state/runs/types';
import {Line} from '../../../util/plotHelpers';
import * as QueryTypes from '../../../util/queryTypes';
import {EditDataTab} from '../../PanelRunsLinePlot/EditPanelTabs/EditDataTab';
import {EditDisplayPreferencesTab} from '../../PanelRunsLinePlot/EditPanelTabs/EditDisplayPreferencesTab';
import {EditExpressionsTab} from '../../PanelRunsLinePlot/EditPanelTabs/EditExpressionsTab';
import {EditGroupingTab} from '../../PanelRunsLinePlot/EditPanelTabs/EditGroupingTab';
import {PanelInteractionProvider} from '../../PanelRunsLinePlot/PanelInteractionContext';
import {RunsLinePlotConfig} from '../../PanelRunsLinePlot/types';
import {SettingsContentWrapper} from '../../WorkspaceDrawer/Settings/components/SettingsContentWrapper';
import {WorkspaceDrawerScroller} from '../WorkspaceDrawerScroller';

interface PanelEditorDrawerProps {
  header: React.ReactNode;
  config: RunsLinePlotConfig;
  updateConfig: (config: RunsLinePlotConfig) => void;
  pageQuery: QueryTypes.Query;
  data: Types.Data;
  lines: Line[];
  query: Types.Query;
}

export const PanelEditorDrawerContent = ({
  header,
  config,
  updateConfig,
  pageQuery,
  data,
  lines,
  query,
}: PanelEditorDrawerProps) => {
  const [selectedTab, setSelectedTab] = useState<string | undefined>('Data');

  const tabs = [
    {
      title: 'Data',
      content: (
        <PanelInteractionProvider activeRunLimit={config.limit}>
          <EditDataTab
            config={config}
            updateConfig={updateConfig}
            lines={lines}
            query={query}
          />
        </PanelInteractionProvider>
      ),
    },
    {
      title: 'Grouping',
      content: (
        <EditGroupingTab
          config={config}
          updateConfig={updateConfig}
          pageQuery={pageQuery}
          data={data}
        />
      ),
    },
    {
      title: 'Display preferences',
      content: (
        <EditDisplayPreferencesTab
          config={config}
          updateConfig={updateConfig}
          pageQuery={pageQuery}
          lines={lines}
        />
      ),
    },
    {
      title: 'Expressions',
      content: (
        <EditExpressionsTab config={config} updateConfig={updateConfig} />
      ),
    },
  ];

  return (
    <WorkspaceDrawerScroller>
      <SettingsContentWrapper header={header} title="Line plot">
        <Tabs.Root value={selectedTab ?? ''} onValueChange={setSelectedTab}>
          <Tabs.List>
            {tabs.map(({title}) => (
              <Tabs.Trigger key={title} data-test={title} value={title}>
                {title}
              </Tabs.Trigger>
            ))}
          </Tabs.List>
          {selectedTab != null && (
            <Tabs.Content value={selectedTab}>
              <div data-test="panel-settings-drawer-content">
                {tabs.find(tab => tab.title === selectedTab)?.content}
              </div>
            </Tabs.Content>
          )}
        </Tabs.Root>
      </SettingsContentWrapper>
    </WorkspaceDrawerScroller>
  );
};
